import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useHolidayListContext } from "context/HolidayListContext";
import { useHasPermission } from "hooks/useHasPermission";
import PublishedAnnouncementList from "../Announcements/PublishedAnnouncementList";
import AdminChart from "./AdminChart";
import { useDispatch, useSelector } from "react-redux";
// import { fetchUpcomingHoliday } from "../../../redux/slice/getUpcomingHolidaySlice";

function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userNameForShowOnDashboard, setUserNameForShowOnDashboard] = useState(null);
  const [greeting, setGreeting] = useState("");
  const canViewRole = useHasPermission("Role-view");
  const canViewEmployee = useHasPermission("Employee-view");
  const canViewCandidate = useHasPermission("Candidate-view");
  const canViewDashboardChart = useHasPermission("Dashboard-chart-view");

  const holidays = useHolidayListContext();
  // const UpcomingHoliday = useSelector(
  //   (state) => state.holidayData.holidays 
  // );
  // extract role for conditional rendering of attendance
  useEffect(() => {
    const getUserNameForShowOnDashboard = localStorage.getItem('name');
    if (getUserNameForShowOnDashboard) {
      const capitalizedUserName = getUserNameForShowOnDashboard.charAt(0).toUpperCase() + getUserNameForShowOnDashboard.slice(1);
      setTimeout(() => {
        setUserNameForShowOnDashboard(capitalizedUserName);
      }, 0);
    }
  }, []);
// console.log("fetchUpcomingHoliday", fetchUpcomingHoliday);
//  useEffect(()=>{
// dispatch(fetchUpcomingHoliday());

//  },[])

  useEffect(() => {
    const updateGreeting = () => {
      const hour = new Date().getHours();
      let newGreeting = "";

      if (hour < 12) {
        newGreeting = "Good morning";
      } else if (hour < 16) {
        newGreeting = "Good afternoon";
      } else {
        newGreeting = "Good evening";
      }
      setGreeting(newGreeting);
    };

    updateGreeting();
    const intervalId = setInterval(updateGreeting, 60000);
    return () => clearInterval(intervalId);
  }, []);


  // to get upcoming holiday
  const nextHoliday = useMemo(() => {
    const today = new Date();
    const currentYear = today.getFullYear();

    // Convert Holiday Dates into Full Date Objects
    const upcoming = holidays.map((holiday) => {
      const [monthStr, day] = holiday.date.split(" ");
      const monthIndex = new Date(`${monthStr} 1, ${currentYear}`).getMonth(); // Uses new Date(${monthStr} 1, ${currentYear}) to get the month index.
      return {
        ...holiday,
        fullDate: new Date(currentYear, monthIndex, Number.parseInt(day)) // Creates a fullDate object
      };
    }).filter((holiday) => holiday.fullDate >= today) // Removes holidays that have already passed (compares fullDate with today)
      .sort((a, b) => a.fullDate - b.fullDate); // Sort Holidays by Date (Closest First)

    return upcoming.length > 0 ? upcoming[0] : null;
  }, [holidays]);
  // const userRole = localStorage.getItem("role");
  // const allowedRoles = ["Head HR", "Admin", "SUPER_ADMIN"];
  return (
    <Container fluid style={{ marginBottom: '30px' }}>
      <Row style={{ marginBottom: '20px', alignItems: 'center' }}>
        <Col md="8">
          <h3 data-search-item style={{ color: "#2c2945", fontWeight: "500", lineHeight: "1.2", fontSize: '20px' }} id="greeting-text">{greeting}, {userNameForShowOnDashboard || "Guest"}! </h3>
        </Col>
      </Row>
      {canViewDashboardChart && (
        <Row className="dashboard-chart">
          <Col md="12">
            <AdminChart />
          </Col>
        </Row>
      )}
      {/* header blocks part */}
      <div className="row clearfix">
        {canViewRole && (
          <div className="col-4 col-md-4 col-xl-2">
            <div className="card">
              <div className="card-body ribbon">
                <a className="sort-cut text-muted" href="/admin/role" style={{ position: 'relative' }}><i className="fa fa-users" aria-hidden="true"></i><span>Roles</span>
                </a>
              </div>
            </div>
          </div>
        )}
        {canViewEmployee && (
          <div className="col-4 col-md-4 col-xl-2">
            <div className="card">
              <div className="card-body ribbon">
                <a className="sort-cut text-muted" href="/admin/employee" style={{ position: 'relative' }}><i className="fa fa-user" aria-hidden="true"></i><span>Employee</span>
                </a>
              </div>
            </div>
          </div>
        )}
        {canViewCandidate && (
          <div className="col-4 col-md-4 col-xl-2">
            <div className="card">
              <div className="card-body ribbon">
                <a className="sort-cut text-muted" href="/admin/candidate" style={{ position: 'relative' }}><i className="fa fa-user" aria-hidden="true"></i><span>Candidate</span>
                </a>
              </div>
            </div>
          </div>
        )}

        <div className="col-4 col-md-4 col-xl-2">
          <div className="card">
            <div className="card-body"><a className="sort-cut text-muted" href="/admin/holidays"><i className="fa fa-thumbs-up" aria-hidden="true"></i><span>Holidays</span></a>
            </div>
          </div>
        </div>
        <div className="col-4 col-md-4 col-xl-2">
          <div className="card">
            <div className="card-body ribbon">
              <a className="sort-cut text-muted" href="/admin/support" style={{ position: 'relative' }}><i className="fa fa-phone" aria-hidden="true"></i><span>Support</span>
              </a>
            </div>
          </div>
        </div>

        {/*<div className="col-6 col-md-4 col-xl-2">
            <div className="card">
              <div className="card-body ribbon">
                <a className="sort-cut text-muted" href="/admin/events" style={{ position: 'relative' }}><i className="fa fa-calendar" aria-hidden="true"></i><span>Events</span>
                </a>
              </div>
            </div>
          </div>
        <div className="col-6 col-md-4 col-xl-2">
          <div className="card">
            <div className="card-body">
              <a className="sort-cut text-muted" href="/admin/dashboard"><i className="fas fa-chart-pie" aria-hidden="true"></i>
                <span>Reports</span></a>
            </div>
          </div>
        </div>*/}

        {canViewCandidate && (
          <div className="col-4 col-md-4 col-xl-2">
            <div className="card">
              <div className="card-body ribbon">
                <a className="sort-cut text-muted" href="/admin/policies" style={{ position: 'relative' }}><i className="fa fa-calendar" aria-hidden="true"></i><span>Policies</span>
                </a>
              </div>
            </div>
          </div>
        )}

        {/* punch-in design */}
        {/* <div className="col-6 col-md-4 col-xl-4">
              <div className="card">
                <div className="punch-container">
                  <div className="timer">
                    <h5>Employee Punch System</h5>
                    <img src={require("assets/img/timer-icon.png")} alt="..." className="timer-icon" />
                    <button className="timer-btn">{formattedTime}</button>

                    <div className="work-mode">
                      <select
                        id="workMode"
                        value={selectedWorkMode}
                        onChange={handleWorkMode}
                      >
                        <option value="office">Office</option>
                        <option value="home">Remote</option>
                      </select>
                    </div>
                  </div>
                  <div className="punchin-btn-container">
                    {punchState === "punchin" && <button
                      onClick={() => handlePunchIn()}
                      className="punchin-btn">Punch In</button>}
                    {punchState === "punchout" && <button
                      onClick={() => handlePunchOut()}
                      className="punchout-btn">Punch Out</button>}
                  </div>
                </div>
              </div>
            </div> */}
      </div>
      {/* graph part */}
      <div className="graph-container">
        <Row>
          <Col md="8">
            <PublishedAnnouncementList />
          </Col>

          {/* quick launch */}
          {/* for admin */}
          <Col md="4">
            {/*<div className="quick-launch-container">
              <div className="card-header" style={{ backgroundColor: '#fff' }}>
                <div className="quick-launch-header-container">
                  <div className="quick-launch-header">
                    <img src={require("assets/img/spark-icon.png")} alt="..." className="spark-icon" />
                    <p className="oxd-text oxd-text--p">Quick Launch</p>
                  </div>
                </div>
                <hr className="oxd-divider" style={{ marginTop: '-8px' }} />
                <div className="diffTabs">
                  <div className="firstColumn">
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/apply-leave">
                        <button className="assign-leave-btn" type="button" title="Assign Leave">
                          <img src={require("assets/img/applyleave-icon.png")} alt="..." className="quick-links-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading" title="Assign Leave">
                          <p className="tabs-heading">Apply Leave</p>
                        </div>
                      </a>
                    </div>
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/leaves">
                        <button className="assign-leave-btn" type="button" title="Leave List">
                          <img src={require("assets/img/leavelist-icon.png")} alt="..." className="quick-links-leavelist-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading" title="Leave List">
                          <p className="tabs-heading" >Leaves</p>
                        </div>
                      </a>
                    </div>
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/dashboard">
                        <button className="assign-leave-btn" type="button" title="Timesheets">
                          <img src={require("assets/img/attendance-icon.png")} alt="..." className="quick-links-timesheet-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading" title="Timesheets">
                          <p className="tabs-heading">Attendance</p>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="secondColumn">
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/dashboard">
                        <button className="assign-leave-btn" type="button" title="Assign Leave">
                          <img src={require("assets/img/training-icon.png")} alt="..." className="quick-links-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading">
                          <p className="tabs-heading">Assign Trainings</p>
                        </div>
                      </a>
                    </div>
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/pendingrequest">
                        <button className="assign-leave-btn" type="button" title="Assign Leave">
                          <img src={require("assets/img/pendingrequest-icon.png")} alt="..." className="quick-links-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading" title="Assign Leave">
                          <p className="tabs-heading">Pending Request</p>
                        </div>
                      </a>
                    </div>
                    <div className="assign-leave-container">
                      <a className="sort-cut" href="/admin/policies">
                        <button className="assign-leave-btn" type="button" title="Assign Leave">
                          <img src={require("assets/img/policies-icon.png")} alt="..." className="quick-links-icon" />
                        </button>
                        <div className="orangehrm-quick-launch-heading" title="Assign Leave">
                          <p className="tabs-heading">Policies</p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            */}
            {/* updated holidays section */}
            <div className="quick-launch-container">
              <div className="card-header" style={{ backgroundColor: '#0000ff3d', color: 'white' }}>
                <div className="quick-launch-header-container">
                  <div className="upcoming-holiday-header">
                    <img src={require("assets/img/congratulation-icon.png")} alt="..." className="congrats-icon" />
                    <p className="upcoming-holiday-heading">Upcoming Holiday</p>
                  </div>
                </div>
                <hr className="oxd-divider" style={{ marginTop: '-8px' }} />
                {/* {nextHoliday && nextHoliday.length > 0 ? (
                    <div className="upcoming-holidays-list">
                 {nextHoliday.map((holiday, index) => (
               <div key={holiday?.id || index} className="upcomingHoliday">
                <div>{holiday.holidayDate}</div>
               <div>{holiday.holidayName}</div>
               <div className="arrow-icon">
              <button 
                type="button" 
                className="btn-interactive" 
                aria-label={`View details for ${holiday.name}`}
                onClick={() => navigate('/admin/holidays')}
              >
                <img 
                  src={require("assets/img/forward-arrow-icon.png")} 
                  alt="upcoming holiday" 
                  aria-hidden="true" 
                />
              </button>
             </div>
             </div>
              ))}
            </div>
                 ): <p className="noUpcomingHoliday">No Upcoming Holiday</p>
                } */}

                                {nextHoliday?.name ? (
                    <div className="upcoming-holidays-list">
                 
               <div className="upcomingHoliday">
                <div>{nextHoliday?.date}</div>
               <div>{nextHoliday?.name}</div>
               <div className="arrow-icon">
              <button 
                type="button" 
                className="btn-interactive" 
                aria-label={`View details for ${nextHoliday?.name}`}
                onClick={() => navigate('/admin/holidays')}
              >
                <img 
                  src={require("assets/img/forward-arrow-icon.png")} 
                  alt="upcoming holiday" 
                  aria-hidden="true" 
                />
              </button>
             </div>
             </div>
            </div>
                 ): <p className="noUpcomingHoliday">No Upcoming Holiday</p>
                }
              </div>
            </div>
            {/* updated birthday section */}
            {/* <div className="quick-launch-container">
              <div className="card-header" style={{ backgroundColor: '#0000ff3d', color: 'white' }}>
                <div className="quick-launch-header-container">
                  <div className="upcoming-holiday-header">
                    <img src={require("assets/img/birthday-icon.png")} alt="..." className="congrats-icon" />
                    <p className="upcoming-holiday-heading">{"Today's Shubham Birthday"}</p>
                  </div>
                </div>
                <hr className="oxd-divider" style={{ marginTop: '-8px' }} />
                <div className="upcomingHoliday">
                  <div>
                    <img src="/static/media/profile-img.322c845998206fafacd2.webp" alt="bday-user" style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #ddd'
                    }} />
                  </div>
                  <div className="birthday-post">
                    <form>
                      <div className="textarea-wrapper">
                        <textarea rows="4" cols="29" value="Wishing a very Happy Birthday to Shubham Singh! 🎉" >
                        </textarea>
                      </div>
                      <div>
                        <button className="post-btn" type="button" >Post</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> */}
          </Col>
        </Row>
      </div>
    </Container >
  );
}

export default Dashboard;
